// extracted by mini-css-extract-plugin
module.exports = {"root":"column-rule_root__25Qwp"};